// Composables
import { useAppStore } from '@/store/app';
import { useAuthStore } from '@/store/auth';
import jwtDecode from 'jwt-decode';
import { createRouter, createWebHistory } from 'vue-router'

import routes from './routes';


function getGroupsRequired(routeTo) {


  if (!routeTo.meta.groupsRequired) return false
  if (typeof routeTo.meta.groupsRequired == 'undefined') return false
  if (typeof routeTo.meta.groupsRequired == 'object') {
    if (routeTo.meta.groupsRequired.length == 0) return false
  }
  return routeTo.meta.groupsRequired
}


function checkRouteAuth(routeTo, routeFrom, next) {
  // const store = useStore()
  const authStore = useAuthStore()


  const authPages = ['/login', '/logout'];
  const is_authpage = authPages.includes(routeTo.path);
  const authRequired = routeTo.matched.some((route) => route.meta.authRequired)
  const groupsRequired = getGroupsRequired(routeTo)


  if (is_authpage) {
    return next();
  }

  // If auth isn't required for the route, just continue.
  if (!authRequired) {
    return next();
  }

  // If auth is required, check if the user is logged in.
  if (!authStore.user.name) {
    router.push("/login")
    return;
  }

  // auth required without groups
  if (!groupsRequired) {
    return next()
  }

  for (let i = 0; i < groupsRequired.length; i++) {
    if (authStore.user.roles.includes(groupsRequired[i])) {
      next();
      break;
    }
  }
}






const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})





router.beforeEach((to, from, next) => {

  const authStore = useAuthStore()

  let refresh = localStorage.getItem("refreshToken")


  // Se il token è nel local stoage controllo che non sia scatuto se non lo è allora controllo con i controlli
  // 
  if(refresh!=null) {



    let decodedToken = jwtDecode(refresh)

    if (Date.now() >= decodedToken.exp * 1000) {
      //Token è scatudo
      localStorage.removeItem("refreshToken")
      location.reload()
    }
    // Se token non scaduto decodo le credenziali del token 

    authStore.decodeToken(refresh)

    return checkRouteAuth(to, from, next);
    
    

  } 

  checkRouteAuth(to, from, next);

})


export default router
